import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'tycka-stars-component',
  styleUrl: 'stars-component.css',
  shadow: true,
})
export class StarsComponent {
  @Prop() rating: number = 5;
  @Prop() fillColor: string = '#000000';
  @Prop() emptyColor: string = '#CED3D8';

  getStarFillValue(index: number) {
    if (index < Math.floor(this.rating)) {
      return 1;
    } else if (index < Math.ceil(this.rating)) {
      return this.rating - Math.floor(this.rating);
    } else {
      return 0;
    }
  }

  render() {
    return (
      <div class="stars">
        {Array.from({ length: 5 }).map((_, index) => {
          const fillValue = this.getStarFillValue(index);
          return <tycka-star-component
            exportparts='variableratingspecialcolor, variablestarsspecialcolor, star'
            fillColor={this.fillColor}
            emptyColor={this.emptyColor}
            filledStar={fillValue}
          />;
        })}
      </div>
    );
  }
}
